import React from 'react';
import { TextField, IconButton, Box } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const DateInputWithArrows = ({ 
  value, 
  onChange, 
  label, 
  fullWidth = false, 
  margin = "normal",
  required = false,
  inputProps = {},
  ...otherProps 
}) => {
  const { t } = useTranslation();
  const handleDateChange = (newDate) => {
    if (onChange) {
      onChange({ target: { value: newDate } });
    }
  };

  const incrementDate = () => {
    if (value) {
      const currentDate = new Date(value);
      currentDate.setDate(currentDate.getDate() + 1);
      const newDate = currentDate.toISOString().split('T')[0];
      handleDateChange(newDate);
    }
  };

  const decrementDate = () => {
    if (value) {
      const currentDate = new Date(value);
      currentDate.setDate(currentDate.getDate() - 1);
      const newDate = currentDate.toISOString().split('T')[0];
      handleDateChange(newDate);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: fullWidth ? '100%' : undefined }}>
      <TextField
        type="date"
        value={value}
        onChange={onChange}
        label={label}
        fullWidth={fullWidth}
        margin="none"
        required={required}
        InputLabelProps={{ shrink: true }}
        inputProps={inputProps}
        sx={{ 
          '& .MuiFormControl-root': { 
            margin: 0 
          },
          margin: 0
        }}
        {...otherProps}
      />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        height: 'fit-content',
        alignSelf: 'flex-start'
      }}>
        <IconButton 
          size="small" 
          onClick={incrementDate}
          disabled={!value}
          title={t('dates.increaseByDay')}
          sx={{ height: 24, width: 24, p: 0 }}
        >
          <KeyboardArrowUp fontSize="small" />
        </IconButton>
        <IconButton 
          size="small" 
          onClick={decrementDate}
          disabled={!value}
          title={t('dates.decreaseByDay')}
          sx={{ height: 24, width: 24, p: 0 }}
        >
          <KeyboardArrowDown fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default DateInputWithArrows;
